import styled from 'styled-components';
import { INFO_COLOR, FONT_SIZE_5, FONT_WEIGHT_BOLD, FONT_SIZE_7 } from '../../../styles/variables';
import { flexPosition, fontStyle } from '../../../styles/mixins';

export const Container = styled.div`
  background-color: ${INFO_COLOR};
  width: 100%;
  height: 80px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;

export const Content = styled.div`
  width: 100%;
  padding: 15px 15px 10px 20px;
`;

export const StepContainer = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  margin-bottom: 13px;
  width: 100%;
`;

export const Step = styled.h2`
  ${fontStyle('#FFF', FONT_SIZE_5, FONT_WEIGHT_BOLD)}
  margin: 0;
`;

export const RemoveStep = styled.button`
  ${fontStyle('#FFF', FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  margin: 0;
  padding: 0;
  outline: none;
  border: none;
  background-color: transparent;
`;

export const Title = styled.p`
  align-items: center;
  border-top: 1px solid transparent;
  display: flex;
  ${fontStyle('#FFF', FONT_SIZE_7, FONT_WEIGHT_BOLD)}
  line-height: 1;
  margin-bottom: 0;
  min-height: 25px;
`;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/StepHeader/style.js